import { Controller } from "@hotwired/stimulus";

// Swaps the submit button to a disabled "Sending..." + spinner state while the preview
// form is in flight, so the page doesn't appear frozen during the synchronous generate.
export default class extends Controller {
  static targets = ["button", "idle", "busy"];

  start() {
    this.buttonTarget.disabled = true;
    this.idleTarget.classList.add("hidden");
    this.busyTarget.classList.remove("hidden");
  }

  end() {
    this.buttonTarget.disabled = false;
    this.busyTarget.classList.add("hidden");
    this.idleTarget.classList.remove("hidden");
  }
}
